import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Tooltip } from '@/components/ui/Tooltip';
import { SpinnerOverlay } from '@/components/ui/Spinner';
import { Building16Regular, People16Regular } from '@fluentui/react-icons';
import { cn } from '@/utils/cn';

interface NavListItem {
  id: string | number;
  title: string;
  status?: string;
}

interface NavListProps {
  makeActive?: (id: string | number) => void;
  data: NavListItem[];
  active: string | number;
  fetchMoreData: () => void;
  hasMore: boolean;
  height?: number;
  dataLength?: any;
}

const NavList: React.FC<NavListProps> = ({ makeActive, data, active, fetchMoreData, hasMore }) => {
  const [activeItem, setActiveItem] = useState(active);

  useEffect(() => {
    setActiveItem(active);
  }, [active]);

  const _makeActive = (id) => {
    setActiveItem(id);
    makeActive?.(id);
  };

  if (!Array.isArray(data) || data.length === 0) return null;

  return (
    <InfiniteScroll
      pageStart={0}
      loadMore={fetchMoreData}
      hasMore={hasMore}
      loader={
        <span className="w-full flex justify-center mt-4">
          <SpinnerOverlay />
        </span>
      }
      useWindow={false}
      className="h-auto"
    >
      {data.map((item, idx) => {
        if (!item) return null;

        const isCompany = item.status === 'COMPANY';
        const isActive = item.id === activeItem;

        return (
          <div
            key={item.id ?? idx}
            data-testid={`nav-list-item-${item.id}`}
            onClick={() => _makeActive(item.id)}
            className={cn(
              'flex items-center gap-2 px-3 py-2.5 border-l-2 border-b border-neutral-100 transition-colors cursor-pointer text-sm',
              isActive
                ? 'bg-primary-50 border-l-brand-600'
                : 'border-l-transparent hover:bg-neutral-25'
            )}
          >
            <span
              className={cn(
                'flex-1 truncate',
                isActive ? 'text-primary-900 font-medium' : 'text-neutral-900'
              )}
            >
              {item.title}
            </span>

            {item.status && (
              <Tooltip content={isCompany ? 'Firemní verze' : 'Komunitní verze'}>
                {isCompany ? (
                  <Building16Regular className="shrink-0 text-neutral-400" />
                ) : (
                  <People16Regular className="shrink-0 text-neutral-400" />
                )}
              </Tooltip>
            )}
          </div>
        );
      })}
    </InfiniteScroll>
  );
};

export default NavList;
